import { parseHtml } from '@healthhub/react-ui';
import { notification } from 'antd';

import RetriveDataErrorAlertBody from './RetriveDataErrorAlertBody';
import styles from './RetriveDataErrorAlertBody.module.css';

const displayAlertInfo = (errorMsg) => {
  // clean up any previously not closed notification
  // this ensure only one alert box to be displayed on the same screen
  notification.destroy();

  const key = new Date().toString();

  notification.open({
    className: styles.retrieveDataErrorAlertBox,
    description: <RetriveDataErrorAlertBody hideHeader message={parseHtml(errorMsg)} />,
    duration: 0,
    key,
    message: null,
    placement: 'bottom',
  });
};

export { displayAlertInfo };
